export default __webpack_public_path__ + "static/media/location-point.235ecd10.gif";